import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import { useLocation } from "react-router-dom";
import AdminConsole from "./components/AdminConsole";
import LeadManagement from "./components/admin/leads/LeadManagement";
import TeamRoute from "./components/TeamRoute";
import Quality from "./components/admin/quality/Quality";
import QualityRoute from "./components/QualityRoute";

import PLMApp from "./components/PLM"; 
import Login from "./components/Login";
import Site from "./components/Site";


function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    const smoother = window.ScrollSmoother?.get();
    if (smoother) {
      smoother.paused(false);
      smoother.scrollTop(0);
      smoother.kill();
    }
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/login"   element={<Login />} />
        <Route path="/product" element={<Navigate to="/products" replace />} />
    

        {/* Protected: any logged-in user */}
        <Route
          path="/plm/:supplierId"
          element={
            <ProtectedRoute>
              <PLMApp />
            </ProtectedRoute>
          }
        />

        {/* Admin-only */}
        <Route
          path="/adminconsole"
          element={
            <AdminRoute>
              <AdminConsole />
            </AdminRoute>
          }
        />
        <Route
  path="/leads/:uid"
  element={
    <TeamRoute>
      <LeadManagement />
    </TeamRoute>
  }
/>
 <Route
  path="/quality/:uid"
  element={
    <QualityRoute>
      <Quality />
    </QualityRoute>
  }
/>

        {/* Public site: home, /products, /info, /about, /contact and its 404 page */}
        <Route path="*" element={<Site />} />
      </Routes>
    </Router>
  );
}

export default App;